// extracted by mini-css-extract-plugin
export var bottom = "Footer-module--bottom--NCJzc";
export var grid = "Footer-module--grid--D7A2Q";
export var img = "Footer-module--img--ReUTc";
export var links = "Footer-module--links--DPazo";
export var logo = "Footer-module--logo--F7l6g";
export var root = "Footer-module--root--VnQEI";
export var social = "Footer-module--social--HtJ4D";